import * as React from "react";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

export default function DataGridTable({ tacherTableData }) {
  const navigate = useNavigate(); // Initialize useNavigate

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      width: 100,
      sortable: false, // Prevent sorting on S.No
      // renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1
    },
    {
      field: 'tname',
      headerName: 'Instructor',
      width: 150,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'eid',
      headerName: 'Email Id',
      width: 300,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'group',
      headerName: 'Group',
      width: 200,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'totalactivestudenton',
      headerName: 'Active Students',
      width: 400,
      align: 'center',
      headerAlign: 'center',
    },
  ];
  const rows = (tacherTableData || []).map((item, index) => ({
    id: index + 1,
    sno: index + 1,
    tname: item.teacher_name,
    eid: item.mail,
    group: item.group,
    totalactivestudenton: item.active_students,
  }));

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}>
      <div style={{ width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          pagination
          //  onRowClick={handleRowClick}
          autoHeight // This prop allows the grid to automatically adjust its height based on the number of rows
          sx={{
            'fontFamily': 'Nunito Sans, sans-serif',
            'fontSize': '14px',
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#ebebeb',
              color: '#000',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '6px',
              fontFamily: 'Nunito Sans, sans-serif',
            },
            '& .MuiDataGrid-cell': {
              padding: '6px',
              fontFamily: 'Nunito Sans, sans-serif',
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        />
      </div>
    </Paper>
  );
}
